var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContentSystem(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "content_system",
    d: "M10.5,7C8,7,6,9,6,11.5S8,16,10.5,16s4.5-2,4.5-4.5S13,7,10.5,7z M10.5,14C9.1,14,8,12.9,8,11.5S9.1,9,10.5,9 s2.5,1.1,2.5,2.5S11.9,14,10.5,14z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "content_system",
    cx: 50,
    cy: 10,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "content_system",
    cx: 46,
    cy: 10,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "content_system",
    cx: 52,
    cy: 13,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "content_system",
    cx: 48,
    cy: 13,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "content_system",
    cx: 42,
    cy: 10,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "content_system",
    cx: 44,
    cy: 13,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "content_system",
    cx: 38,
    cy: 10,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "content_system",
    cx: 40,
    cy: 13,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "content_system",
    cx: 34,
    cy: 10,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "content_system",
    cx: 36,
    cy: 13,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "content_system",
    d: "M60,17.4V5.6C60,3.1,57.9,1,55.4,1H4.6C2.1,1,0,3.1,0,5.6v11.8c0,1.5,0.7,2.8,1.8,3.6C0.7,21.8,0,23.1,0,24.6 v11.8C0,38.9,2.1,41,4.6,41H29v8.1c-2,0.4-3.5,1.9-3.9,3.9H1c-0.6,0-1,0.4-1,1s0.4,1,1,1h24.1c0.5,2.3,2.5,4,4.9,4s4.4-1.7,4.9-4 H59c0.6,0,1-0.4,1-1s-0.4-1-1-1H34.9c-0.4-2-1.9-3.5-3.9-3.9V41h24.4c2.5,0,4.6-2.1,4.6-4.6V24.6c0-1.5-0.7-2.8-1.8-3.6 C59.3,20.2,60,18.9,60,17.4z M33,54c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S33,52.3,33,54z M58,24.6v11.8c0,1.4-1.2,2.6-2.6,2.6H4.6 C3.2,39,2,37.8,2,36.4V24.6C2,23.2,3.2,22,4.6,22h50.8C56.8,22,58,23.2,58,24.6z M4.6,20C3.2,20,2,18.8,2,17.4V5.6 C2,4.2,3.2,3,4.6,3h50.8C56.8,3,58,4.2,58,5.6v11.8c0,1.4-1.2,2.6-2.6,2.6H4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "content_system",
    d: "M10.5,35c2.5,0,4.5-2,4.5-4.5S13,26,10.5,26S6,28,6,30.5S8,35,10.5,35z M10.5,28c1.4,0,2.5,1.1,2.5,2.5 S11.9,33,10.5,33S8,31.9,8,30.5S9.1,28,10.5,28z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "content_system",
    cx: 50,
    cy: 29,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "content_system",
    cx: 46,
    cy: 29,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "content_system",
    cx: 52,
    cy: 32,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "content_system",
    cx: 48,
    cy: 32,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "content_system",
    cx: 42,
    cy: 29,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "content_system",
    cx: 44,
    cy: 32,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "content_system",
    cx: 38,
    cy: 29,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "content_system",
    cx: 40,
    cy: 32,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "content_system",
    cx: 34,
    cy: 29,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "content_system",
    cx: 36,
    cy: 32,
    r: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentSystem);
export default __webpack_public_path__ + "static/media/content_system.f68be5f2fa8f8afad20ef92e53891704.svg";
export { ForwardRef as ReactComponent };